import { c as _c } from "react/compiler-runtime";
import { STORE_API } from 'modules/stores/api/stores-api';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
export const useStoreItemActions = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher) {
    const reorderItem = (itemId, position) => fetcher(`${STORE_API}/items/${itemId}/change-position`, {
      position
    });
    t1 = {
      reorderItem
    };
    $[1] = fetcher;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};